module.exports = __webpack_public_path__ + "img/7be20d1.png";